import React, { useEffect, useState } from "react";
import { db } from "../../../firebaseConfig";
import {
  collection,
  getDocs,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import classes from "./DailyWebHistory.module.css";

const DailyWebHistory = () => {
  const [archives, setArchives] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch archived daily webs
  useEffect(() => {
    const fetchArchives = async () => {
      try {
        const snap = await getDocs(collection(db, "dailyweb_results"));

        // Fallback if 'id' isn't a field → use doc.id (the date)
        const docs = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Sort descending by date
        docs.sort((a, b) => new Date(b.id) - new Date(a.id));
        console.log(docs);

        setArchives(docs);
      } catch (err) {
        console.error("Error loading archives:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchArchives();
  }, []);

  if (loading) return <p className={classes.loading}>Loading Daily Web history...</p>;

  return (
    <div className={classes.container}>
      <h1 className={classes.title}>🌐 Daily Web History</h1>
      <p className={classes.subtitle}>Explore all previous daily webs from our community</p>

      {archives.length === 0 && <p>No archived webs yet!</p>}

      <div className={classes.grid}>
        {archives.map((archive) => (
          <div
            key={archive.id}
            className={classes.card}
            onClick={() => navigate(`/daily-web-history/${archive.id}`)}
          >
            <div className={classes.cardHeader}>
              <h3 className={classes.date}>{archive.id}</h3>
            </div>

            <div className={classes.preview}>
              {archive.nodes?.length ? (
                <>
                  <p className={classes.question}>
                    {archive.nodes[0]?.question || "Untitled question"}
                  </p>
                  <div className={classes.previewStats}>
                    <span>{archive.nodes.length} nodes</span>
                    <span>{archive.links?.length || 0} links</span>
                  </div>
                </>
              ) : (
                <p className={classes.empty}>No data for this day</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DailyWebHistory;
